module.exports = __webpack_public_path__ + "img/promo1.198ef7ef.jpg";